module.exports = __webpack_public_path__ + "img/bell.3846233.png";